import { createContext } from 'react';
import { markType } from './constants/basemarks';
import { FrameStatus, SelectedFrame } from './hooks/useForecastFrames';

type PredicionMapContextType = {
  sliderValue: number;
  setSliderValue: React.Dispatch<React.SetStateAction<number>>;
  calculatedTime: Date | null;
  setCalculatedTime: React.Dispatch<React.SetStateAction<Date | null>>;
  imageIdList: string[];
  // 起算時刻に応じた目盛り. 初期値と一緒に親で決める.
  sliderMarks: markType;
  // 選択中の時刻の取得状態と、実際に地図に出ている時刻（取得中は前の時刻のまま）.
  selectedFrame: SelectedFrame | null;
  displayedValidTimeMs: number | null;
  requestFrame: (validTimeMs: number) => FrameStatus;
  retrySelected: () => void;
};

const PredicionMapContext = createContext<PredicionMapContextType>({} as PredicionMapContextType);

export default PredicionMapContext;
